import Vue from 'vue'
import {BootstrapVue} from 'bootstrap-vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex';
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'regenerator-runtime'
import CookieLaw from 'vue-cookie-law'
import Slick from 'vue-slick'
import VueMobileDetection from 'vue-mobile-detection'

var VueScrollTo = require('vue-scrollto');

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueMobileDetection)
Vue.use(VueScrollTo)


const strings = translations

Vue.prototype.$t = function (text, domain) {
    if (translations[domain]) {
        if (translations[domain][text]) {
            return translations[domain][text]
        }
    }
    console.warn("nieznalezione tłumaczenie", text, domain)
    return "uknow translations"
}

import VuexStore from './store'

Vue.use(VueAxios, axios)

const store = new Vuex.Store(VuexStore)
Vuex.Store.prototype.axios = axios


//import componenets
import Cart from './components/cart/cart.vue'
import OpenCart from './components/nav/open_cart.vue'
import ProductsList from './components/products/products_list.vue'
import Dropdown from './components/nav/dropdown.vue'
import Searcher from './components/nav/searcher.vue'
import MyAccountBtn from './components/nav/my-account-btn.vue'
import Subscriber from './components/newsletter/subscrier.vue'
import PopupNewsletter from './components/popups/popup_newsletter.vue'
import Product from './components/products/product.vue'
import ProductGallery from './components/sliders/product_gallery.vue'
import Checkout from './components/chceckout/checkout.vue'
import ThankYou from './components/chceckout/thankyou.vue'
import UserRegister from './components/user/user_register.vue'
import UserLogin from './components/user/user_login.vue'
import PopupLogin from './components/user/popups/login.vue'
import PopupRegister from './components/user/popups/register.vue'
import PopupForgot from './components/user/popups/forgot_password.vue'
import OrderHistory from './components/user/my-account/order-history.vue'
import UserAddresses from './components/user/my-account/addresses.vue'
import YourAccount from './components/user/my-account/your-account.vue'
import RegisterForms from './components/user/register_forms.vue'
import YourDeliveryPopup from './components/popups/popup_your_delivery.vue'
import PaymentMethodsPopup from './components/popups/popup_payment_methods.vue'
import ContactForm from './components/forms/contact.vue'
import ShopsList from './components/shops-list/shops-list.vue'
import Alert from './components/alerts/alert.vue'
import SearcherMobile from './components/nav/searcher_mobile.vue'

window.addEventListener('load', function () {

    let Nav = Vue.extend({
        store,
        data() {
            return {
                sticky: false,
                buttonActive: false,
            }
        },
        mounted() {
            window.document.onscroll = () => {
                let navBar = document.getElementById('header-top');
                if (window.scrollY > navBar.offsetTop + 20) {
                    this.sticky = true;
                    document.getElementById('header-top').classList.add('header-top__sticky')
                } else {
                    this.sticky = false;
                    document.getElementById('header-top').classList.remove('header-top__sticky')
                }
            }
        },
        beforeCreate() {
            for (let el of document.getElementsByClassName("menu-dropdown-component")) {
                el.classList.remove('d-none');
            }
        },
        methods: {
            collapsedNav() {
                this.buttonActive = !this.buttonActive;
                document.getElementById('header-top').classList.toggle('header-top__collapsed')
            }
        },
        components: {OpenCart, Dropdown, Searcher, MyAccountBtn, SearcherMobile}
    });
    if (document.getElementById("vue_nav")) {
        new Nav().$mount('#vue_nav')
    }

    let CartObj = Vue.extend({
        store,
        components: {Cart}
    });
    if (document.getElementById("cart")) {
        new CartObj().$mount('#cart')
    }

    let Cookie = Vue.extend({
        components: {CookieLaw}
    });
    if (document.getElementById("cookie_bar")) {
        new Cookie().$mount('#cookie_bar')
    }

    let Popups = Vue.extend({
        store,
        components: {PopupNewsletter}
    });
    if (document.getElementById("popups")) {
        new Popups().$mount('#popups')
    }

    let MainCarousel = Vue.extend({
        components: {Slick},
        data() {
            return {
                mainSlider: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: false,
                    draggable: false,
                    pauseOnHover: false,
                    asNavFor: '.promotial__slider__dots',
                    arrows: false,
                    dots: false,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    useTransform: false,
                    fade: true,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                useTransform: false,
                                infinite: true,
                                dots: true,
                                customPaging: function (slider, i) {
                                    return '<span class="custom-dot"></span>';
                                },
                            }
                        }
                    ]
                },
                mainSliderDots: {
                    asNavFor: '.promotial__slider',
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    // useTransform: false,
                    draggable: true,
                    swipeToSlide: true,
                    vertical: true,
                    verticalSwiping: true,
                    centerMode: true,
                    centerPadding: 40,
                    arrows: false,
                    dots: false,
                    focusOnSelect: true
                }
            }
        }
    });
    if (document.getElementById("mainSlider")) {
        new MainCarousel().$mount('#mainSlider')
    }

    let ComponentProductsList = Vue.extend({
        store,
        // propsData: {
        //     strings: strings
        // },
        components: {ProductsList}
    });
    if (document.getElementById("component_products_list")) {
        new ComponentProductsList().$mount('#component_products_list')
    }

    let Footer = Vue.extend({
        store,
        components: {Subscriber}
    })
    if (document.getElementById("footer")) {
        new Footer().$mount('#footer')
    }

    let ProductObj = Vue.extend({
        store,
        components: {Product, ProductGallery, YourDeliveryPopup},
        props: ["product_id"],
        computed: {
            productDataAreAvailable() {
                let available = this.$store.getters['product/getProductAvailableStatus'];
                if (available) {
                    document.getElementById("product-content-row").classList.remove('d-none')
                }
                return available
            }
        },
        methods: {
            detect_mobile() {
                return this.$isMobile()
            },
            show_delivery_popup() {
                this.$store.dispatch('shipping_zones/getShippingZones').then(() => {
                    this.$store.commit('info_boxes/popup_delivery_visibility', true)
                })
            }
        }
    })
    if (document.getElementById("product")) {
        new ProductObj().$mount('#product')
    }

    let RecommendedProduct = Vue.extend({
        components: {Slick},
        data() {
            return {
                recommendedOptions: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: '<button class="slider__arrow slider__arrow--from-top slider__arrow__prev"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22"><g><path fill="none" stroke="#c3cdd3" stroke-linecap="square" stroke-miterlimit="20" stroke-width="1.4" d="M11 1v0L1 11v0l10 10v0"/></g></svg></button>',
                    nextArrow: '<button class="slider__arrow slider__arrow--from-top slider__arrow__next"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22"><g><path fill="none" stroke="#c3cdd3" stroke-linecap="square" stroke-miterlimit="20" stroke-width="1.4" d="M1 1v0l10 10v0L1 21v0"/></g></svg></button>',
                    dots: false,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false,
                            }
                        },
                        {
                            breakpoint: 568,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false,
                            }
                        }
                    ]
                }
            }
        }
    })
    if (document.getElementById("recommendedProducts")) {
        new RecommendedProduct().$mount('#recommendedProducts')
    }

    let Accordion = Vue.extend({})
    if (document.getElementById("accordions")) {
        new Accordion().$mount('#accordions')
    }

    let CheckoutObj = Vue.extend({
        store,
        components: {Checkout}
    })
    if (document.getElementById("checkout")) {
        new CheckoutObj().$mount('#checkout')
    }

    let ThankYou = Vue.extend({
        store,
        components: {ThankYou}
    })
    if (document.getElementById("thankyou")) {
        new ThankYou().$mount('#thankyou')
    }

    let User = Vue.extend({
        store,
        components: {
            UserRegister,
            UserLogin,
            PopupLogin,
            PopupRegister,
            PopupForgot
        },
        computed: {
            cart_not_empty() {
                return this.$store.getters['cart/get_cart_count'] < 1
            },
            checkout_link() {
                return (this.$store.getters['cart/get_cart_count'] < 1 ? false : this.$store.getters['cart/get_checkout_link'])
            }
        }
    })
    if (document.getElementById("user_forms")) {
        new User().$mount('#user_forms')
    }

    let UserAccount = Vue.extend({
        store,
        data() {
            return {
                your_accounts: {
                    data: false,
                    history: true,
                    addresses: false,
                }
            }
        },
        components: {
            OrderHistory,
            YourAccount,
            UserAddresses
        },
        methods: {
            show_data_component() {
                this.your_accounts.data = true
                this.your_accounts.history = false
                this.your_accounts.addresses = false
            },
            show_history_component() {
                this.your_accounts.data = false
                this.your_accounts.addresses = false
                this.your_accounts.history = true
            },
            show_addresses_component() {
                this.your_accounts.data = false
                this.your_accounts.history = false
                this.your_accounts.addresses = true
            }
        }
    })
    if (document.getElementById("user_panel")) {
        new UserAccount().$mount('#user_panel')
    }

    let RegisterForm = Vue.extend({
        store,
        components: {RegisterForms}
    })
    if (document.getElementById("register_forms")) {
        new RegisterForm().$mount('#register_forms')
    }

    let InfoBoxes = Vue.extend({
        store,
        components: {
            YourDeliveryPopup,
            PaymentMethodsPopup
        },
        data() {
            return {
                loading_popup_your_delivery: false,
                loading_popup_where_buy_it: false,
                loading_popup_payment_methods: false,
            }
        },
        methods: {
            click_box_your_delivery(event) {
                this.loading_popup_your_delivery = true
                this.$store.dispatch('shipping_zones/getShippingZones').then(() => {
                    this.loading_popup_your_delivery = false
                    this.$store.commit('info_boxes/popup_delivery_visibility', true)
                })
            },
            click_box_payment_methods(event) {
                this.loading_popup_payment_methods = true
                this.$store.dispatch('checkout/getCheckoutMethods').then(() => {
                    this.loading_popup_payment_methods = false
                    this.$store.commit('info_boxes/popup_payment_methods_visibility', true)
                })
            }
        }
    })
    if (document.getElementById("info_boxes")) {
        new InfoBoxes().$mount('#info_boxes')
    }

    let Contact = Vue.extend({
        store,
        components: {ContactForm}
    })
    if (document.getElementById("contact_form")) {
        new Contact().$mount('#contact_form')
    }

    let ShopsListObj = Vue.extend({
        store,
        components: {ShopsList}
    })
    if (document.getElementById("shops_list")) {
        new ShopsListObj().$mount('#shops_list')
    }

    let AlertsObj = Vue.extend({
        store,
        components: {Alert}
    })
    if (document.getElementById("alerts")) {
        new AlertsObj().$mount('#alerts')
    }



});
